// @ts-ignore
import React from "react";
import AppTokenMng from "./AppTokenMng";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import "react-toastify/dist/ReactToastify.css";

// Import del sistema di theming
import { ThemeNames } from "./themes/themeTypes";
import { getTheme } from "./themes/themeRegistry";
import Typography from "@mui/material/Typography";

// CONFIGURAZIONE TEMA DA UTILIZZARE
const SELECTED_THEME = ThemeNames.SYSTEL; // Cambia qui per usare un tema diverso

// Logica per determinare il tema automaticamente (opzionale)
const getSelectedTheme = (): string => {
    const isTestEnv = process.env.APP_NAME === "tema_tst" || process.env.APP_NAME === "Gow_tst";
    // const isDevelopment = process.env.NODE_ENV === "development";

    if (isTestEnv) return ThemeNames.TEST;
    // if (isDevelopment) return ThemeNames.DEVELOPMENT;

    return SELECTED_THEME; // Usa quello configurato sopra
};

const App: React.FC = () => {
    const selectedTheme = getSelectedTheme();
    const theme = getTheme(selectedTheme);

    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="it">
                <ToastContainer autoClose={3000} hideProgressBar pauseOnHover={true} />
                <AppTokenMng />
            </LocalizationProvider>
        </ThemeProvider>
    );
};

export default App;
